module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00033-fs8.8a30f71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00033-fs8.png
// module id = 186
// module chunks = 0